import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MemberModel } from '@bayclubs/group-classes-employee-api';
import { Subscription, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemberSearchFormService {

    memberSearchForm: UntypedFormGroup;
    subscriptions: Subscription;
    constructor(private formBuilder: UntypedFormBuilder) {
        this.subscriptions = new Subscription();
    }

    onDestroy() {
        this.subscriptions.unsubscribe();
    }

    public getMemberForm(): UntypedFormGroup {
        this.memberSearchForm = this.formBuilder.group({
            member: [null]
        });
        this.wireUpControlChanges();
        return this.memberSearchForm;
    }

    private wireUpControlChanges() {
    }

    public getSearchPhraseValueChanges(): Observable<any> {
        return this.memberSearchForm.get('member').valueChanges;
    }

    getSearchPhrase(): string {
        return this.memberSearchForm.get('member').value;
    }

    setFormValue(member: MemberModel) {

    }
}
